import { useEffect } from "react";
import api from "../lib/apiClient";

function sessionId() {
  let s = localStorage.getItem("neostore_session");
  if (!s) {
    s = crypto?.randomUUID ? crypto.randomUUID() : "sess-" + Math.random().toString(36).slice(2) + Date.now();
    localStorage.setItem("neostore_session", s);
  }
  return s;
}

// Lightweight presence heartbeat — powers the admin "visitors on site now" count.
export default function PresenceTracker() {
  useEffect(() => {
    const ping = () => { api.post("/presence/ping", { session_id: sessionId() }).catch(() => {}); };
    ping();
    const id = setInterval(ping, 15000);
    const onVisible = () => { if (document.visibilityState === "visible") ping(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", onVisible); };
  }, []);
  return null;
}
